import { getRoutingAdapter } from '@shell/adapters/routing'
import type { NavigateOptions } from '@shell/contracts'
import * as React from 'react'

import { RouteLinkProps } from './interface'
import { StyledLink } from './style'

const RouteLink: React.FC<RouteLinkProps> = (props) => (
  <StyledLink
    key={props.path}
    onClick={() => {
      if (props.path === '/learning-path' && props.studentSFiD) {
        localStorage.removeItem(`lp:${props.studentSFiD}:activeHash`)
      }
      const target = props.dynamicPath || props.path
      // Only pass displayAs when a dynamicPath is set — masking the internal route
      // with the clean public path. When there is no dynamicPath, displayAs would
      // equal target and passing it is redundant.
      const options: NavigateOptions = props.dynamicPath ? { displayAs: props.path } : {}
      if (props.replace) {
        void getRoutingAdapter().replace(target, options)
      } else {
        void getRoutingAdapter().navigate(target, options)
      }
    }}
    withHoverEffect={props.withHoverEffect}
    {...props}
  >
    {props.children}
  </StyledLink>
)

export default RouteLink
